import { Card, Transition } from '@mantine/core';
import appSettings from '../appsettings.json';
import AudioWave from "./misc/AudioWave";

type SongPreviewProps = {
	isOpen: boolean,
	type: string
	songId: string
};

const SongPreview: React.FC<SongPreviewProps> = ({ isOpen, type, songId }) => {

	const previewHeight = 150;
	const previewWidth = 300;
	const top = type === "marketplace" ? 480 : 400;

	return (
		<Transition mounted={isOpen} transition="slide-down" duration={400}>
			{(transitionStyles) => (
				<Card
					shadow="md"
					w={previewWidth}
					h={previewHeight}
					pos="absolute"
					right={0}
					top={top}
					bg="#E8F1F9"
					style={{
						...transitionStyles,
						zIndex: 1,
						border: "1px solid #222",
						display: "flex"
					}}
				>
					<Card.Section style={{ height: "100%" }} id="song_wave">
						<AudioWave url={`${appSettings.S3BucketBaseUrl}MarketplaceMP3s/${songId}.mp3`} />
					</Card.Section>
				</Card>
			)}
		</Transition>
	);
}

export default SongPreview;